import { render, staticRenderFns } from "./InputComp.vue?vue&type=template&id=055663d0&scoped=true&"
import script from "./InputComp.vue?vue&type=script&lang=js&"
export * from "./InputComp.vue?vue&type=script&lang=js&"
import style0 from "./InputComp.vue?vue&type=style&index=0&id=055663d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055663d0",
  null
  
)

export default component.exports